import z from 'zod';
import { ComponentType } from '$lib/sanity/types';
import { SanityDocumentSchema } from '../sanity';
import { ImageAssetSchema } from './Image';
import { TextBlockSchema } from './Text';
import { VideoSchema } from './Video';

export const MediaSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.Media),
  type: z.union([z.literal('image'), z.literal('video')]),
  image: ImageAssetSchema.nullish(),
  video: VideoSchema.nullish(),
  caption: z
    .object({
      copy: z.array(TextBlockSchema).nullish(),
      width: z.string(),
      alignment: z.union([z.literal('left'), z.literal('center'), z.literal('right')])
    })
    .nullish()
});

export type Media = z.infer<typeof MediaSchema>;
